module.exports = __webpack_public_path__ + "img/icon-game-tbt.982b8cfb.png";